// src/Common/Forms/Enums/FormPropertyFieldType.cs
export enum FieldType {
  Text = "Text",
  TextArea = "TextArea",
  Number = "Number",
  Checkbox = "Checkbox",
  DropDown = "DropDown",
  MultiSelectDropDown = "MultiSelectDropDown",
  AutoComplete = "AutoComplete",
  MultiSelectAutoComplete = "MultiSelectAutoComplete",
  Date = "Date",
  DateRange = "DateRange",
  PercentCompleteSlider = "PercentCompleteSlider",
  Attachment = "Attachment",
  MultiAttachment = "MultiAttachment",
  TextAreaWithMentions = "TextAreaWithMentions",
  Switch = "Switch",
  CheckboxMultiSelectDropDown = "CheckboxMultiSelectDropDown",
}
